import { render, staticRenderFns } from "./QRCodeGallery.vue?vue&type=template&id=4fd2caa8"
import script from "./QRCodeGallery.vue?vue&type=script&lang=js"
export * from "./QRCodeGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports